import React, { useState, useEffect } from 'react';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import TwitterAccountSettings from '../Settings/TwitterAccountSettings';
import './Settings.css';
import { getAuth, signOut } from 'firebase/auth';

const Settings = ({ user, onClose }) => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accountCount, setAccountCount] = useState(1);

  useEffect(() => {
    loadUserProfile();
  }, [user]);

  // Force refresh profile when switching tabs or performing actions
  const forceRefreshProfile = async () => {
    try {
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        console.log('⚙️ Settings: Force refreshing profile on action:', data);
        console.log('⚙️ Settings: Raw twitterUsernames:', data.twitterUsernames);
        console.log('⚙️ Settings: Raw accountCount:', data.accountCount);
        
        // Clean up corrupted data if needed
        let cleanedData = { ...data };
        if (Array.isArray(data.twitterUsernames)) {
          const validUsernames = data.twitterUsernames.filter(u => u && typeof u === 'string' && u.trim() !== '');
          cleanedData.twitterUsernames = validUsernames;
          cleanedData.accountCount = validUsernames.length;
          
          // If we cleaned invalid data, update Firebase
          if (validUsernames.length !== data.twitterUsernames.length) {
            console.log('🧹 Force refresh: Cleaning corrupted twitterUsernames data in Firebase');
            await updateDoc(doc(db, 'users', user.uid), {
              twitterUsernames: validUsernames,
              accountCount: validUsernames.length
            });
          }
          
          setAccountCount(validUsernames.length);
          console.log('⚙️ Settings: Valid usernames found:', validUsernames);
        } else {
          setAccountCount(0);
          console.log('⚙️ Settings: No usernames found');
        }
        
        setUserProfile(cleanedData);
      }
    } catch (error) {
      console.error('Error force refreshing profile:', error);
    }
  };

  const loadUserProfile = async () => {
    try {
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        console.log('⚙️ Settings: Force refreshing user profile:', data);
        console.log('⚙️ Settings: Raw twitterUsernames (load):', data.twitterUsernames);
        console.log('⚙️ Settings: Raw accountCount (load):', data.accountCount);
        
        // Clean up corrupted data if needed
        let cleanedData = { ...data };
        if (Array.isArray(data.twitterUsernames)) {
          const validUsernames = data.twitterUsernames.filter(u => u && typeof u === 'string' && u.trim() !== '');
          cleanedData.twitterUsernames = validUsernames;
          cleanedData.accountCount = validUsernames.length;
          
          // If we cleaned invalid data, update Firebase
          if (validUsernames.length !== data.twitterUsernames.length) {
            console.log('🧹 Cleaning corrupted twitterUsernames data in Firebase');
            await updateDoc(doc(db, 'users', user.uid), {
              twitterUsernames: validUsernames,
              accountCount: validUsernames.length
            });
          }
          
          setAccountCount(validUsernames.length);
          console.log('⚙️ Settings: Valid usernames found (load):', validUsernames);
        } else {
          setAccountCount(0);
          console.log('⚙️ Settings: No usernames found (load)');
        }
        
        setUserProfile(cleanedData);
      }
    } catch (error) {
      console.error('Error loading user profile:', error);
    } finally {
      setLoading(false);
    }
  };







  const getCurrentUsernames = () => {
    // ONLY read from twitterUsernames array - no backward compatibility
    const usernames = Array.isArray(userProfile?.twitterUsernames) ? userProfile.twitterUsernames : [];
    
    // Filter out null/undefined/empty values
    const validUsernames = usernames.filter(u => u && typeof u === 'string' && u.trim() !== '');
    console.log('⚙️ Settings getCurrentUsernames:', { 
      original: usernames, 
      filtered: validUsernames,
      accountCount: userProfile?.accountCount 
    });
    
    return validUsernames;
  };

  const getAccountStatus = () => {
    if (userProfile?.isUnlimited) return 'unlimited';
    const usernames = getCurrentUsernames();
    if (usernames.length === 0) return 'none';
    return 'limited';
  };

  if (loading) {
    return (
      <div className="settings-overlay">
        <div className="settings-modal">
          <div className="settings-loading">
            <div className="loading-spinner"></div>
            <p>Loading settings...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h2>⚙️ Settings</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

         

                <div className="settings-content">
          <TwitterAccountSettings user={user} />
        </div>
        <div style={{ padding: '2rem', borderTop: '1px solid rgba(255,255,255,0.08)', textAlign: 'center' }}>
          <button
            className="logout-btn"
            onClick={() => {
              const auth = getAuth();
              signOut(auth).then(() => {
                window.location.reload();
              });
            }}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings; 